import React, { FC } from 'react';
import HeroUnit from 'components/organisms/HeroUnit';
import { Container, CircularProgress, Grid } from '@material-ui/core';
import useArticles from 'hooks/use-articles';
import PatternCard from 'components/organisms/PatternCard';
import ReactIcon from '../../logo.svg';

const Home: FC = () => {
  const { articles, loading } = useArticles({ limit: 50 });

  return (
    <>
      <HeroUnit />
      <Container maxWidth="md">
        {loading ? (
          <CircularProgress />
        ) : (
          <Grid container spacing={4}>
            {articles.map(article => (
              <PatternCard
                key={article.id}
                id={article.id}
                title={article.title}
                imageSrc={ReactIcon}
              />
            ))}
          </Grid>
        )}
      </Container>
    </>
  );
};

export default Home;
